module.exports = __webpack_public_path__ + "media/images/weather/102_day-c75e99bd12117356af740c434184a43d.png";